import cx from 'classnames';
import OrganicTopShape from 'themes/organic/assets/organic_top_shape.svg';

import { OrganicFooter } from '../Footer/OrganicFooter';
import { OrganicMinimalHeader } from './OrganicMinimalHeader';

import s from './OrganicLayout.module.css';

interface MinimalLayoutProps {
  children?: React.ReactNode;
}

export const OrganicMinimalLayout = ({ children }: MinimalLayoutProps) => {
  return (
    <div className={cx(s.layout, s.minimal)}>
      <div className={s.topShapeContainer}>
        <OrganicTopShape />
      </div>
      <OrganicMinimalHeader />
      <div className={s.container}>{children}</div>
      <OrganicFooter />
    </div>
  );
};
